var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { WMLogger } from '@mobilize/logging';
import { Dictionary, Inject } from '../Application';
import { Constants, Events, Order } from '../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
var METHODNOTIMPLEMENTED = 'Method not implemented.';
var ModelResolver = (function () {
    function ModelResolver(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject || Inject.Instance;
        this.modelFactory = this.inject.resolve(Constants.ModelFactory);
        this.event = this.inject.resolve(Constants.EventAggregator);
        this.behaviors = new Dictionary();
        this.requiredBehaviors = new Dictionary();
        this.notifiers = new Array();
        this.myIsSynchronizing = false;
        this.PreProcessArray = function () { };
        this.PostProcessArray = function () { };
    }
    ModelResolver.prototype.init = function (buffer) {
        this.buffer = buffer;
    };
    ModelResolver.prototype.registerNotifier = function (notifier) {
        if (this.notifiers.some(function (item) { return item === notifier; })) {
            this.notifiers[this.notifiers.indexOf(notifier)] = notifier;
        }
        else {
            this.notifiers.push(notifier);
        }
    };
    ModelResolver.prototype.registerBehavior = function (behavior, required) {
        if (required === void 0) { required = false; }
        if (!this.behaviors.containsKey(behavior.Order.toString())) {
            this.behaviors.add(behavior.Order.toString(), []);
        }
        else if (required) {
            if (!this.requiredBehaviors.containsKey(behavior.Order.toString())) {
                this.requiredBehaviors.add(behavior.Order.toString(), []);
            }
            this.addBehavior(behavior, this.requiredBehaviors);
        }
        this.addBehavior(behavior, this.behaviors);
    };
    ModelResolver.prototype.process = function () {
        var behaviors = this.getBehaviors(this.behaviors);
        this.applyBehaviors(behaviors, this.buffer.toArray());
        this.resolveArrayDeltas(this.buffer.toArray().filter(function (model) { return model['@arr']; }));
    };
    ModelResolver.prototype.attachModels = function (modelDeltas) {
        var _this = this;
        this.myIsSynchronizing = true;
        var models = this.propagateDeltas(modelDeltas);
        var newModels = models[0];
        var modifiedModels = models[1];
        var stubModels = this.createMissingHierarchy(newModels);
        newModels = newModels.concat(stubModels);
        var behaviors = this.getBehaviors(this.behaviors);
        this.applyBehaviors(behaviors, newModels);
        var requiredBehaviors = this.getBehaviors(this.requiredBehaviors);
        this.applyBehaviors(requiredBehaviors, modifiedModels);
        this.resolveArrayDeltas(modelDeltas.filter(function (model) {
            return model.UniqueID.length > 0 && _this.buffer.getModel(model.UniqueID)['@arr'];
        }));
        this.myIsSynchronizing = false;
    };
    ModelResolver.prototype.removeModels = function (models) {
        var _this = this;
        this.myIsSynchronizing = true;
        models.forEach(function (model) {
            _this.detachModel(model);
            _this.buffer.deleteCascade(model.UniqueID);
        });
        this.myIsSynchronizing = false;
    };
    ModelResolver.prototype.switchIds = function (ids) {
        var _this = this;
        ids.forEach(function (item) { return _this.buffer.switchIds(item[0], item[1]); });
    };
    ModelResolver.prototype.isCoreSynchronizing = function () {
        return this.myIsSynchronizing;
    };
    ModelResolver.prototype.detachModel = function (model) {
        var parent = this.buffer.getParentByModel(model);
        if (parent) {
            parent.removeModel(model);
        }
    };
    ModelResolver.prototype.getBehaviors = function (collection) {
        if (collection === void 0) { collection = this.behaviors; }
        return {
            evt: this.notifiers,
            ord: collection.value(Order.ORD.toString()) || [],
            post: collection.value(Order.POST.toString()) || [],
            pre: collection.value(Order.PRE.toString()) || []
        };
    };
    ModelResolver.prototype.applyBehaviors = function (behaviors, models) {
        var _this = this;
        models.forEach(function (model) { return _this.attachIsSynchronizingClient(model); });
        behaviors.pre.forEach(function (behavior) {
            models.forEach(function (model) { return _this.tryApplyBehaviors(behavior, model); });
        });
        behaviors.ord.forEach(function (behavior) {
            models.forEach(function (model) { return _this.tryApplyBehaviors(behavior, model); });
        });
        behaviors.post.forEach(function (behavior) {
            models.forEach(function (model) { return _this.tryApplyBehaviors(behavior, model); });
        });
        behaviors.evt.forEach(function (notify) {
            models.forEach(function (model) { return _this.tryApplyBehaviors(notify, model); });
        });
    };
    ModelResolver.prototype.replaceBehavior = function (oldBehaviorName, behavior) {
        var items = this.behaviors.value(behavior.Order.toString()) || [];
        if (items.length > 0) {
            var oldBehavior = items.filter(function (item) { return item.constructor.name === oldBehaviorName; });
            if (oldBehavior != null) {
                items[items.indexOf(oldBehavior[0])] = behavior;
            }
            else {
                this.registerBehavior(behavior);
            }
        }
        else {
            this.registerBehavior(behavior);
        }
    };
    ModelResolver.prototype.resolveAdded = function (addedModels) {
        throw new Error(METHODNOTIMPLEMENTED);
    };
    ModelResolver.prototype.resolveChanged = function (changedModels) {
        throw new Error(METHODNOTIMPLEMENTED);
    };
    ModelResolver.prototype.resolveRemoved = function (removedIds) {
        var _this = this;
        this.myIsSynchronizing = true;
        removedIds.forEach(function (id) {
            var model = _this.modelFactory.create({ UniqueID: id });
            if (model) {
                _this.detachModel(model);
                _this.buffer.deleteCascade(model.UniqueID);
            }
        });
        this.myIsSynchronizing = false;
    };
    ModelResolver.prototype.removePendingActions = function () {
        this.event.publish(Events.DeletePendingActions, this.buffer.removedModels);
        this.buffer.removedModels = [];
    };
    ModelResolver.prototype.resolveValueTypeArray = function (models, Observable) {
        var index;
        for (index = 0; index < models.length; index++) {
            Observable.addValueArray(Observable, models[index], index);
        }
        return index;
    };
    ModelResolver.prototype.resolveStateObjectAndSurrogateArray = function (models, Observable) {
        var index;
        for (index = 0; index < models.Count; index++) {
            var element = this.buffer.getModel(models.uids[index]);
            if (element !== null) {
                Observable.addValueArray(Observable, element, index);
            }
            else {
                Observable.addValueArray(Observable, this.modelFactory.create({ UniqueID: '' }), index);
            }
        }
        return index;
    };
    ModelResolver.prototype.resolveObjectArray = function (models, Observable) {
        var index;
        for (index = 0; index < models.Count; index++) {
            var element = this.buffer.getModel(models.uids[index]);
            if (element !== null) {
                Observable.addValueArray(Observable, element, index);
            }
            else {
                Observable.addValueArray(Observable, models.uids[index], index);
            }
        }
        return index;
    };
    ModelResolver.prototype.resolveArrayDeltas = function (arrayDeltas) {
        for (var _i = 0, arrayDeltas_1 = arrayDeltas; _i < arrayDeltas_1.length; _i++) {
            var iter = arrayDeltas_1[_i];
            this.PreProcessArray(iter);
            var delta = iter;
            var arrayObservable = this.buffer.getModel(delta.UniqueID);
            if (!arrayObservable.isRoot() && !arrayObservable.isPointer) {
                var index = void 0;
                switch (delta['ltype']) {
                    case 1:
                        index = this.resolveValueTypeArray(delta['uids'], arrayObservable);
                        break;
                    case 2:
                    case 3:
                        index = this.resolveStateObjectAndSurrogateArray(delta, arrayObservable);
                        break;
                    case 4:
                        index = this.resolveObjectArray(delta, arrayObservable);
                        break;
                }
                if (delta['uids'].length < arrayObservable['length']) {
                    arrayObservable.removeValueAray(arrayObservable, index, arrayObservable['length'] - delta['uids'].length);
                }
            }
            this.PostProcessArray(delta);
            if (!arrayObservable.hasCircularReference()) {
                arrayObservable.fireChange();
            }
        }
    };
    ModelResolver.prototype.addBehavior = function (behavior, collection) {
        var items = collection.value(behavior.Order.toString());
        if (items.some(function (item) { return item === behavior; })) {
            items[items.indexOf(behavior)] = behavior;
        }
        else {
            items.push(behavior);
        }
    };
    ModelResolver.prototype.propagateDeltas = function (modelDeltas) {
        var _this = this;
        var newModels = [];
        var updateModels = [];
        modelDeltas.forEach(function (item) {
            if (item.UniqueID.length > 0) {
                if (_this.buffer.exists(item)) {
                    _this.updateModel(item);
                    updateModels.push(item);
                }
                else {
                    newModels.push(item);
                    _this.buffer.add(item);
                }
            }
        });
        return [newModels, updateModels];
    };
    ModelResolver.prototype.attachIsSynchronizingClient = function (model) {
        var _this = this;
        var item = this.buffer.getModel(model.UniqueID);
        item.isCoreSynchronizing = function () { return _this.isCoreSynchronizing(); };
    };
    ModelResolver.prototype.updateModel = function (item) {
        var model = this.buffer.getModel(item.UniqueID);
        if (model) {
            model.updateModel(item);
        }
        else {
            WMLogger.instance().error('This models is not in the buffer. Please check the Backend response in the removed area.');
        }
    };
    ModelResolver.prototype.tryApplyBehaviors = function (behavior, model) {
        try {
            behavior.apply(this.buffer.getModel(model.UniqueID), this.buffer);
        }
        catch (e) {
            WMLogger.instance().error("Error procesing an behavior ".concat(e).concat(e.stack));
        }
    };
    ModelResolver.prototype.createMissingHierarchy = function (models) {
        var stubModels = [];
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var mod = models_1[_i];
            var hierarchy = this.createMissingParent(mod, this.buffer);
            if (hierarchy.length > 0) {
                stubModels = stubModels.concat(hierarchy);
            }
        }
        return stubModels;
    };
    ModelResolver.prototype.createMissingParent = function (model, buffer) {
        var stubModels = [];
        if (!model.isRoot()) {
            var parent_1 = buffer.getParentByModel(model);
            if (!parent_1) {
                var parentData = { UniqueID: model.parentName() };
                if (!isNaN(parseFloat(model.uniqueName()))) {
                    parentData['@arr'] = 1;
                }
                var parentStub = this.modelFactory.create(parentData);
                stubModels.push(parentStub);
                buffer.add(parentStub);
                var hierarchy = this.createMissingParent(parentStub, buffer);
                if (hierarchy.length > 0) {
                    stubModels = stubModels.concat(hierarchy);
                }
            }
        }
        return stubModels;
    };
    ModelResolver = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], ModelResolver);
    return ModelResolver;
}());
export { ModelResolver };
